import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import Select, { SelectItem } from '../ui/Select';
import ApplicationContext from '../ApplicationContext';
import { Country } from '../ifmsTypes';
import { ComboParamsBase, FmsComboType } from '../fms.core/constants';

function CountryIsoCodeDropDown({
  value,
  onChange = () => { },
  disabled = false,
  items = [],
  selectId = undefined,
  maxLength = undefined,
  notFocusNextEleWhenSelectItem = false,
  name= undefined,
}: {
  value: Country|null,
  onChange?: (x:Country|null) => void,
  disabled?: boolean,
  items?: Array<Country>,
  selectId?: string|undefined,
  maxLength?: number|undefined,
  notFocusNextEleWhenSelectItem?: boolean,
  name?: string|undefined,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<Country>>([]);

  async function fetchData(api:any) {
    //const apiResult = await api.getCodesCountries({orderBy: 'name', orederByAscending: true});
    //setData(apiResult ? apiResult.data : []);
    var base = new ComboParamsBase();
    base.comboType = FmsComboType.IsoCountry;
    const data = await api.loadCodeData([base]);
    if (data && data.length > 0) {
      setData(data[0].items);
    }
  }

  function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.value) {
      onChange(null);
      return;
    }

    const element = data.find(x => x.isoCode === e.target.value);
    onChange(element ?? null);
  }

  useEffect(() => {
    if (items && items.length) {
      setData(items);
    } else {
      fetchData(appContext.api);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const displayData:Array<SelectItem> = [
    {value: '', label: '', activeLabel: '' },
    ...data.map(x => ({ value: x.isoCode ?? '', label: `${x.isoCode} - ${x.name}`, activeLabel: x.isoCode ?? undefined }))
  ];

  return (
    <Select
      name={name}
      notFocusNextEleWhenSelectItem={notFocusNextEleWhenSelectItem}
      maxLength={maxLength}
      selectId={selectId}
      value={(value === null || value === undefined) ? '' : value.isoCode ?? ''}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
    />
  );
}

CountryIsoCodeDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
};

CountryIsoCodeDropDown.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  items: PropTypes.array,
  selectId: PropTypes.string,
  maxLength: PropTypes.number,
};

export default React.memo(CountryIsoCodeDropDown);
